module.exports = __webpack_public_path__ + "static/media/testimonial-scott.9fdbd715.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/testimonial-scott.jpg
// module id = 1193
// module chunks = 0